// Search Handler

window.utmbWeb = window.utmbWeb || {};
(function (config) {

    if(config.useSearchMenu && (!config.pageIsDesignMode || config.pageIsPreviewMode)) {

        function submitSearch(searchQuery) {
            window.location.href = 'https://www.utmb.edu/search?q=' + searchQuery.replace(" ", "+");
        }

        function desktopSearch() {
            var searchQuery = document.getElementById('SearchQuery').value;
            if (searchQuery) {
                submitSearch(searchQuery);
            }
        }

        function desktopSearchKeyMonitor(event) {
            if (event) {
                if (event.keyCode === 13) {
                    var searchQuery = document.getElementById('SearchQuery').value;
                    if (searchQuery) {
                        submitSearch(searchQuery);
                    }
                }
            }
        }

        function mobiSearch() {
            var searchQuery = document.getElementById('MobiSearchQuery').value;
            if (searchQuery) {
                submitSearch(searchQuery);
            }
        }

        function mobiSearchKeyMonitor(event) {
            if (event) {
                if (event.keyCode === 13) {
                    var searchQuery = document.getElementById('MobiSearchQuery').value;
                    if (searchQuery) {
                        submitSearch(searchQuery);
                    }
                }
            }
        }

        window.addEventListener('keyup', desktopSearchKeyMonitor);
        window.addEventListener('keyup', mobiSearchKeyMonitor);
    }

})(window.utmbWeb);